// appConstants.js

const SUPPORT_EMAIL = 'support@banxa.com';

export default { SUPPORT_EMAIL };
